import { render, staticRenderFns } from "./SdeptCusOrder.vue?vue&type=template&id=5cffee2a&"
import script from "./SdeptCusOrder.vue?vue&type=script&lang=ts&"
export * from "./SdeptCusOrder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports